import axios from 'axios';
import Logger from '../logger';

import Storage from '../helpers/storage.helpers';
import { API_URL_PREFIX } from '../config';

import has from 'lodash/has';
import assign from 'lodash/assign';

/* eslint no-magic-numbers: 0 */

const logger = new Logger('http');

const URL_BASE = _removeEndSlashes(API_URL_PREFIX);
const config = { credentials: true };

class HttpService {
   @wrapper
   get(path, options = {}) {
      logger.debug('get data from', path, ', options', options);
      return axios.get(path, options);
   }

   @wrapper
   delete(path, options = {}) {
      logger.debug('delete data from', path, ', options', options);
      return axios.delete(path, options);
   }

   @wrapper
   post(path, body, options = {}) {
      logger.debug('post data to', path, ', body', body, ', options', options);
      return axios.post(path, body, options);
   }

   @wrapper
   put(path, body, options = {}) {
      logger.debug('put data to', path, ', body', body, ', options', options);
      return axios.put(path, body, options);
   }
}

export function prepareUrl(path) {
   path = _removeFirstSlashes(path);
   return `${URL_BASE}/${path}`;
}

function _removeEndSlashes(str) {
   const idx = str.lastIndexOf('/');
   return idx === str.length - 1 ? _removeEndSlashes(str.slice(0, idx)) : str;
}

// "/path"     => "path"
// "path"      => "path"
// "///path"   => "path"
function _removeFirstSlashes(str) {
   return str[0] === '/' ? _removeFirstSlashes(str.slice(1)) : str;
}

function wrapper(target, name, descriptor) {
   const method = descriptor.value;
   const length = method.length;
   descriptor.value = function _resolveArgumentsDecorator(...args) {
      args[0] = prepareUrl(args[0]);
      if (length === 2) {
         args[1] = args[1];
      }
      args[length] = Object.assign({}, config, args[length]);

      args[length].headers = {
         authorization: Storage.get('guard', 'auth-key'),
         language: Storage.get('user', 'language')
      };

      if ( has(args[length], 'params') ) {
         args[length].params = args[length].params;
      }

      return method.apply(this, args).then(_proccess);
   };
}

function _proccess(resp) {
   let answer = resp.data;
   logger.debug('proccess response ', answer);
   if (resp.status >= 200 || resp.status < 400) {
      const auth = (resp.headers || {}).authorization;
      if (auth) {
         Storage.set('guard', 'auth-key', auth);
      }
      return answer;
   }

   return Promise.reject(answer);
}

export default new HttpService();
